<template lang="pug">
sidebar.sidebar(ref="menuSidebar",
  placement="left",
  header="Debut",
  :show="isShowMenuSidebar",
  :width="offCanvasWidth")
  .row
    .col-xs-12
      accordion.mobile-menu(:one-at-atime="true")
        ul.style-none.mobile-menu--header.clearfix
          router-link.pointer(tag="li",
            :to="{ name: 'homepage' }",
            :class="{ hasUnderTriangle : displayDebutHeader }",
            @click.native="close") {{ $t('header.debut') }}
          router-link.pointer(tag="li",
            :to="{ name: 'companySignup' }",
            :class="{ hasUnderTriangle : displayCompanyHeader }",
            @click.native="close") {{ $t('header.manipulator') }}
        ul.mobile-menu--sub-menu
          router-link.pointer(tag="li",
            :to="{ name: 'internsList' }",
            :class="{ hasUnderTriangle : displayDebutHeader }",
            @click.native="close") {{ $t('header.findJob') }}
          router-link.pointer(tag="li",
            :to="{ name: 'companyList' }",
            :class="{ hasUnderTriangle : displayDebutHeader }",
            @click.native="close") {{ $t('header.findCompany' )}}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { aside, accordion, panel } from 'vue-strap'

const offCanvasWidth = 320

export default {
  props: {
    displaySubNav: {
      type: Boolean,
      default: false
    },
    activeSubNav: {
      type: String,
      default: ''
    }
  },
  components: {
    sidebar: aside,
    accordion: accordion,
    panel: panel
  },
  computed: {
    displayDebutHeader () {
      if (typeof this.$store.state.route !== 'undefined') {
        if (typeof this.$store.state.route.meta !== 'undefined') {
          return this.$store.state.route.meta.displayDebutHeader || false
        }
      }
      return true
    },
    displayCompanyHeader () {
      if (typeof this.$store.state.route !== 'undefined') {
        if (typeof this.$store.state.route.meta !== 'undefined') {
          return this.$store.state.route.meta.displayCompanyHeader || false
        }
      }
      return false
    },
    ...mapGetters({
      isShowMenuSidebar: 'utilities/isShowMenuSidebar',
      isShowUserSidebar: 'utilities/isShowUserSidebar'
    })
  },
  methods: {
    close () {
      this.toggleMenuSidebar(false)
    },
    ...mapActions({
      toggleMenuSidebar: 'utilities/toggleMenuSidebar'
    })
  },
  data () {
    let locale = 'tw'
    if (typeof this.$route.params !== 'undefined' &&
      typeof this.$route.params.locale !== 'undefined') {
      locale = this.$route.params.locale
    }

    return {
      locale: locale,
      offCanvas: window.innerWidth <= 991,
      offCanvasWidth: offCanvasWidth
    }
  },
  mounted () {
    this.$refs.menuSidebar.$on('close', () => {
      this.toggleMenuSidebar(false)
    })
  }
}
</script>
<style lang="sass" scoped>
@import "~globalStyles/variables"
.sidebar
  background-color: #333333
  color: white
  font-size: 16px
  .mobile-menu
    ul.mobile-menu--header
      li
        font-size: 1.25em
        @media screen and (max-width: $breakpoint-vs)
          padding-top: 10px
    .mobile-menu--sub-menu
      list-style: none
      li
        padding: 0.5em 0
      a
        @media screen and (max-width: $breakpoint-vs)
          padding-top: 45px
  .pointer
    cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/menuOffcanvas.vue